var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "TrialCancellationContainer",
    { attrs: { title: "What plan are you interested in?" } },
    [
      _c("FlagBasedSurvey", {
        attrs: {
          options: _vm.options,
          "survey-api-endpoint-route-name":
            "payment_trial_cancel_different_plan_survey_submit",
          "abort-btn-text": _vm.abortBtnTextOverride
        },
        on: {
          "chose-option": _vm.choseOption,
          "survey-posted": function($event) {
            return _vm.actionHandler("next")
          },
          abort: function($event) {
            return _vm.actionHandler("abort")
          }
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }